<div class="loading-container" [ngClass]="'loading-' + size">
  <div class="multiple1">
    <div class="ball1"></div>
    <div class="ball2"></div>
    <div class="ball3"></div>
  </div>
  <span *ngIf="message" class="loading-message">{{ message }}</span>
</div>

